export default __webpack_public_path__ + "static/media/ShawnMcPheeWebsite.fb763fe8.pdf";